import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Landing from './Landing';
import Katanaut from './Katanaut';
import KatanautPress from './KatanautPress';
import Othercrown, { OthercrownPress } from './Othercrown';
import StudioBackdrop from './StudioBackdrop';
import Contact from './Contact';
import './App.css';

function StudioBackgroundRoute() {
  const { pathname } = useLocation();
  return <StudioBackdrop visible={pathname === '/'} />;
}

function App() {
  return (
    <HelmetProvider>
      <Router>
          <StudioBackgroundRoute />
          {/* Studio-level defaults. Each game page overrides these with its own. */}
          <Helmet>
            <title>Voidmaw</title>
            <meta name="description" content="Voidmaw is a one-person game studio." />
            <meta property="og:url" content="https://www.voidmaw.com" />
            <meta property="og:type" content="website" />
            <meta property="og:title" content="Voidmaw" />
            <meta property="og:description" content="Voidmaw is a one-person game studio." />
            <meta property="og:image" content="https://i.imgur.com/QHYTfGa.png" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta property="twitter:domain" content="voidmaw.com" />
            <meta property="twitter:url" content="https://www.voidmaw.com" />
            <meta name="twitter:title" content="Voidmaw" />
            <meta name="twitter:description" content="Voidmaw is a one-person game studio." />
            <meta name="twitter:image" content="https://i.imgur.com/QHYTfGa.png" />
          </Helmet>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/katanaut" element={<Katanaut />} />
          <Route path="/katanaut/press-kit" element={<KatanautPress />} />
          <Route path="/Press.html" element={<Navigate to="/katanaut/press-kit" replace />} />
          <Route path="/othercrown" element={<Othercrown />} />
          <Route path="/othercrown/press-kit" element={<OthercrownPress />} />
          <Route path="/coming-soon" element={<Navigate to="/othercrown" replace />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/press-kit" element={<Navigate to="/katanaut/press-kit" replace />} />
          {/* Anything unknown falls back to the games list. */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
